import { Link } from "react-router-dom";
import { CheckCircle, ArrowLeft, Mail, Calendar } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <section className="pt-24 pb-20 lg:pt-32 lg:pb-28">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-forest-900/30 border border-forest-800/30 mb-8">
            <CheckCircle className="text-forest-500" size={40} />
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold text-foreground">
            Demo Request Received!
          </h1>

          <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-lg mx-auto">
            Thank you for your interest in CompostDeveloper. Our team will reach out within one business day to schedule your personalized demo.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto">
            <div className="bg-card border border-border rounded-lg p-5">
              <Mail className="text-forest-500 mx-auto mb-3" size={24} />
              <h3 className="text-sm font-semibold text-foreground">Check Your Inbox</h3>
              <p className="text-xs text-muted-foreground mt-1">We've sent a confirmation email with details about what to expect.</p>
            </div>
            <div className="bg-card border border-border rounded-lg p-5">
              <Calendar className="text-forest-500 mx-auto mb-3" size={24} />
              <h3 className="text-sm font-semibold text-foreground">We'll Reach Out</h3>
              <p className="text-xs text-muted-foreground mt-1">Expect a call or email within 1 business day to confirm your demo time.</p>
            </div>
          </div>

          <div className="mt-10">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
